import React from 'react';

import { Card } from '@ergeon/core-components';
import { Money } from '@ergeon/erg-utils-js';

import { Order } from '../../../types';

import OrderCard from './OrderCard';
import OrderCardSkeleton from './OrderCardSkeleton';

type PipelineColumnProps = {
  title: string;
  orders: Order[];
  orderCount: number;
  totalValue: number;
  onOrderClick?: (order: Order) => void;
  isLoading?: boolean;
};

const SKELETON_COUNT = 1;

const PipelineColumn: React.FC<PipelineColumnProps> = ({ title, orders, orderCount, totalValue, onOrderClick, isLoading }) => {
  const orderLabel = orderCount === 1 ? 'order' : 'orders';
  const valueDisplay = totalValue === 0 ? '$0' : Money.toString(totalValue);

  return (
    <Card className="flex flex-col flex-1 shrink-0 min-w-44 p-2 gap-2" flavor="regular" zIndex="1">
      <div className="flex flex-col gap-0.5 flex-shrink-0">
        <h3 className="text-gray-900 dark:text-white paragraph-2 font-semibold truncate">{title}</h3>
        <p className="text-gray-500 dark:text-gray-400 paragraph-3 truncate">
          {isLoading ? (
            <span className="inline-block h-3 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
          ) : (
            `${valueDisplay} · ${orderCount} ${orderLabel}`
          )}
        </p>
      </div>
      <div className="flex flex-col gap-2">
        {isLoading ?
          Array.from({ length: SKELETON_COUNT }).map((_, index) => <OrderCardSkeleton key={`skeleton-${index}`} />) :
          orders.map((order) => (
            <OrderCard key={order.id} onClick={() => onOrderClick?.(order)} order={order} />
          ))}
      </div>
    </Card>
  );
};

export default PipelineColumn;
